import { ListInvitation } from "models/list-invitation";
import { doGet, doPost, parseListPath } from "../request";
import { List } from "models/list";

export const adminDoGetListInvitations = async (list: List) => {
  const invitations = await doGet<ListInvitation[]>(
    parseListPath(list, "invitations"),
  );
  return invitations;
};

export const adminDoPostListUserInvitation = async (
  list: List,
  userUuid: string,
) => {
  const invitation = await doPost<ListInvitation>(
    parseListPath(list, "invitation"),
    { userUuid },
  );
  return invitation;
};
